import { render } from "./providerSelector.vue?vue&type=template&id=3b7fe327&scoped=true&ts=true"
import script from "./providerSelector.vue?vue&type=script&lang=ts"
export * from "./providerSelector.vue?vue&type=script&lang=ts"

import "./providerSelector.vue?vue&type=style&index=0&id=3b7fe327&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7fe327"]])

export default __exports__